import { render, staticRenderFns } from "./CustomAccordionButton.vue?vue&type=template&id=400d0af2&scoped=true"
import script from "./CustomAccordionButton.vue?vue&type=script&lang=js"
export * from "./CustomAccordionButton.vue?vue&type=script&lang=js"
import style0 from "./CustomAccordionButton.vue?vue&type=style&index=0&id=400d0af2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400d0af2",
  null
  
)

export default component.exports